module.exports = __webpack_public_path__ + "static/media/zippyclip-5.dfed4b2d.jpg";